<template>
    <div v-frag>
        <CardIeaAppMain colorCard="#A7BA38" title="">
            <!-- <v-row> -->
            <v-col cols="12" sm="12" xs="12" md="12" lg="12" xl="12">
                <v-btn class="mx-2" dark small color="success" @click="$router.push({
                    name: 'Home'
                });">
                    Menú
                </v-btn>
                <br />
                <br />
                <v-row>
                    <v-col sm="12" xs="12" md="3">
                        <div class="panel1">
                            <v-list style="background: transparent;">
                                <v-list-item-group>

                                    <v-list-item @click="create">
                                        <v-list-item-avatar>
                                            <v-icon class="primary lighten-1" dark>
                                                mdi-plus
                                            </v-icon>
                                        </v-list-item-avatar>

                                        <v-list-item-content>
                                            <v-list-item-title>Crear nuevo tema</v-list-item-title>
                                        </v-list-item-content>
                                    </v-list-item>

                                </v-list-item-group>
                            </v-list>
                        </div>
                        <div class="panel1" v-if="foro">
                            <v-list style="background: transparent;">
                                <v-list-item-group>
                                    <v-list-item @click="foro = null">
                                        <v-list-item-icon>
                                            <v-icon>
                                                mdi-arrow-left
                                            </v-icon>
                                        </v-list-item-icon>

                                        <v-list-item-content>
                                            <v-list-item-title>Volver</v-list-item-title>
                                        </v-list-item-content>
                                    </v-list-item>
                                    <v-list-item @click="openParticipants">
                                        <v-list-item-icon>
                                            <v-icon>
                                                mdi-account-multiple
                                            </v-icon>
                                        </v-list-item-icon>

                                        <v-list-item-content>
                                            <v-list-item-title>Integrantes del foro</v-list-item-title>
                                        </v-list-item-content>
                                    </v-list-item>
                                    <v-list-item @click="editForum(idForo)" v-if="foro.alumno_id == user.IDStB">
                                        <v-list-item-icon>
                                            <v-icon>
                                                mdi-pencil
                                            </v-icon>
                                        </v-list-item-icon>

                                        <v-list-item-content>
                                            <v-list-item-title>Editar</v-list-item-title>
                                        </v-list-item-content>
                                    </v-list-item>
                                    <v-list-item @click="deleteForum" v-if="foro.alumno_id == user.IDStB">
                                        <v-list-item-icon>
                                            <v-icon>
                                                mdi-delete
                                            </v-icon>
                                        </v-list-item-icon>

                                        <v-list-item-content>
                                            <v-list-item-title>Eliminar</v-list-item-title>
                                        </v-list-item-content>
                                    </v-list-item>

                                    <v-list-item @click="requestAcess()" v-if="!isParticipant()">
                                        <v-list-item-icon>
                                            <v-icon>mdi-lock-open</v-icon>
                                        </v-list-item-icon>

                                        <v-list-item-content>
                                            <v-list-item-title>Solicitar acceso</v-list-item-title>
                                        </v-list-item-content>
                                    </v-list-item>
                                </v-list-item-group>
                            </v-list>
                        </div>
                        <div class="panel1">
                            <h4>Secciones</h4>
                            <v-list style="background: transparent;">
                                <v-list-item-group v-model="selectedCategory" color="primary">
                                    <v-list-item @click="selectCategory(null)">
                                        <v-list-item-icon>
                                            <span class="bullet"></span>
                                        </v-list-item-icon>
                                        <v-list-item-content>
                                            <v-list-item-title>Todas las secciones</v-list-item-title>
                                        </v-list-item-content>
                                    </v-list-item>
                                    <v-list-item v-for="(item, i) in categories" :key="i" @click="selectCategory(item)">
                                        <v-list-item-icon>
                                            <span class="bullet" :style="{ 'background-color': item.color }"></span>
                                        </v-list-item-icon>
                                        <v-list-item-content>
                                            <v-list-item-title v-text="item.name"></v-list-item-title>
                                        </v-list-item-content>
                                    </v-list-item>
                                </v-list-item-group>
                            </v-list>
                        </div>
                    </v-col>

                    <v-col xs="12" sm="12" md="9" v-if="foro">
                        <template>
                            <v-card class="mx-auto">
                                <v-toolbar flat>
                                    <v-btn icon @click="foro = null">
                                        <v-icon>mdi-arrow-left</v-icon>
                                    </v-btn>
                                    <v-toolbar-title>
                                        {{ foro.title }}
                                        <v-chip v-if="foro.type == 'private'" color="primary" small>
                                            <v-icon>mdi-lock</v-icon> Privado
                                        </v-chip>
                                    </v-toolbar-title>
                                    <v-spacer></v-spacer>
                                    <v-toolbar-title>{{ foro.likes }}</v-toolbar-title>
                                    <v-btn icon @click="like" :disabled="liked">
                                        <v-icon>mdi-thumb-up-outline</v-icon>
                                    </v-btn>
                                    <v-btn icon @click="dislike" :disabled="disliked">
                                        <v-icon>mdi-thumb-down-outline</v-icon>
                                    </v-btn>
                                </v-toolbar>

                                <v-divider></v-divider>

                                <v-card-text>
                                    <v-row>
                                        <div class="avatar-column">
                                            <div class="avatar-wrapper">
                                                <v-avatar size="60" color="#8fc6dc" style="border:6px solid #e5e3e2">
                                                    <v-img v-if="foro.alumno != null" :src="foro.alumno.imagen"></v-img>
                                                    <v-img v-if="foro.profesor != null"
                                                        :src="foro.profesor.empleado.imagen"></v-img>
                                                </v-avatar>
                                            </div>
                                        </div>
                                        <div class="text-column">
                                            <div class="text-name">
                                                {{ foro.alumno.Nombres }} {{ foro.alumno.Apellidos }}
                                            </div>
                                            <div class="date-wrapper" style="padding-top: 10px; padding-bottom: 10px;">
                                                <small class="primary--text-edit">{{ relativeDate(foro.created_at)
                                                    }}</small>
                                            </div>
                                            <div class="text-category" :style="{ 'color': foro.category.color }">
                                                {{ foro.category.name }}
                                            </div>
                                            <p v-html="foro.content" class="content-forum"></p>
                                        </div>

                                    </v-row>
                                    <v-row>
                                        <v-carousel hide-delimiters
                                            :show-arrows="(foro.images.length >= 2) || (foro.images.length == 1 && foro.video) ? true : false"
                                            v-if="foro.images.length >= 2 || foro.video" height="300">
                                            <v-carousel-item
                                                v-for="(image, j) in foro.images.filter(d => { return (d.status == 1) })"
                                                :key="j" :src="image.image"
                                                @click="openPublication(foro)"></v-carousel-item>
                                            <v-carousel-item v-if="foro.video">
                                                <video width="100%" height="400" controls>
                                                    <source :src="foro.video" type="video/mp4">
                                                </video>
                                            </v-carousel-item>
                                        </v-carousel>
                                        <v-img v-if="foro.images.length == 1" :src="foro.images[0].image"></v-img>
                                    </v-row>
                                </v-card-text>
                            </v-card>
                        </template>

                        <br /><br /><br />
                        <v-row v-if="isParticipant()" class="responsive-comment-row">
                            <v-col xs="11" sm="12" md="12" class="textarea-column">
                                <v-textarea solo name="input-7-4" label="Escribe tu comentario" rows="4"
                                    v-model="comment" class="responsive-font responsive-padding custom-textarea">
                                </v-textarea>

                                <v-btn depressed color="primary" @click="addComment()">
                                    Enviar
                                </v-btn>
                            </v-col>
                        </v-row>



                        <v-alert type="info" v-else>
                            Para agregar comentarios debes ser integrante de este foro <v-btn color="primary darken-1"
                                small @click="requestAcess()">Solicitar acceso</v-btn>
                        </v-alert>
                        <br>
                        <div v-if="foro.comments.length > 0">
                            <div style="display: flex; align-items: center; color: white; font-size: 1rem;">
                                <v-icon style="margin-right: 5px; color: white;">mdi-comment</v-icon>
                                {{ foro.comments.length }} comentarios
                            </div>

                            <v-timeline align-top dense style="border-color: white;">
                                <v-timeline-item v-for="(comment, j) in foro.comments" :key="j" large color="#8fc6dc">
                                    <template v-slot:icon>
                                        <v-avatar size="50" title="Ver perfil">
                                            <div class="v-image v-responsive theme--light">
                                                <div class="v-responsive__sizer" style="padding-bottom: 190.399%;">
                                                </div>
                                                <div class="v-image__image v-image__image--cover" :style="{
                                                    'background-image': 'url(' + comment.alumno.imagen + ')',
                                                    'background-position': 'center center'
                                                }"></div>
                                                <div class="v-responsive__content" style="width: 1229px;"></div>
                                            </div>
                                        </v-avatar>
                                    </template>
                                    <v-card class="elevation-2">
                                        <v-card-actions style="padding-left: 20px;">
                                            <v-spacer></v-spacer>
                                            <v-btn icon v-if="comment.alumno_id == user.IDStB"
                                                @click="deleteComment(comment, j)">
                                                <v-icon small color="grey">mdi-delete</v-icon>
                                            </v-btn>
                                            <v-btn icon v-else></v-btn>
                                        </v-card-actions>
                                        <v-card-text style="margin-top: -50px">
                                            <strong>{{ comment.alumno.Nombres }}</strong>
                                            <br />
                                            <p class="mb-5" style="color:#464646" v-html="comment.comment"></p>
                                            <small class="primary--text-2">
                                                Hace {{ gettime(comment.updated_at) }}
                                            </small>
                                            <small class="warning--text" style="margin-left: 10px;">
                                                <v-btn icon @click="likeComment(comment)" class="warning--text">
                                                    {{ comment.likes }}
                                                    <v-icon color="orange" small>mdi-thumb-up-outline</v-icon>
                                                </v-btn>
                                            </small>
                                            <br />
                                        </v-card-text>
                                    </v-card>
                                </v-timeline-item>
                            </v-timeline>

                        </div>
                        <div v-else>
                            <v-alert type="info">
                                Sé el primero en comentar
                            </v-alert>
                        </div>
                    </v-col>

                    <v-col xs="12" sm="12" md="9" v-else>
                        <div class="v-scroll-x">
                            <h2 v-if="category"
                                class="text-xs-h4 text-sm-h4 text-md-h4 text-lg-h4 text-xl-h4 primary--text"
                                style="color: white !important;">
                                {{ category.name }}
                            </h2>

                            <!-- <v-simple-table v-if="items.length > 0"> -->
                            <v-col cols="12" xs="12" sm="12" md="12" xl="12" lg="12"
                                v-if="items.length == 0 && show == true">
                                <v-alert prominent type="info">
                                    No se ha publicado aún ningún tema {{ category ? 'en la categoría ' + category.name
                                    : '' }}
                                </v-alert>
                            </v-col>
                            <v-simple-table v-else>
                                <template v-slot:default>
                                    <thead v-if="items.length > 0">
                                        <tr v-if="$vuetify.breakpoint.mdAndUp">
                                            <th class="text-left responsive-font">Temas</th>
                                            <th class="text-left responsive-font">Respuestas</th>
                                            <th class="text-left responsive-font">Likes</th>
                                            <th class="text-left responsive-font">Últimos</th>
                                        </tr>
                                    </thead>
                                    <tbody>
                                        <tr v-for="(item, i) in items" :key="i" @click="openForo(item.id, item)">
                                            <td class="responsive-padding">
                                                <v-row v-if="item.alumno != null" class="centered-avatar">
                                                    <v-col xs="2" sm="2" md="2" class="centered-avatar">
                                                        <v-avatar :size="$vuetify.breakpoint.smAndDown ? 50 : 60"
                                                            :style="{
                                                                border: '6px solid #e5e3e2',
                                                                backgroundColor: getColor()  /* Aquí usamos getColor() para el relleno */
                                                            }">
                                                            <v-img :src="item.alumno.imagen"
                                                                v-if="item.alumno.imagen"></v-img>
                                                            <v-icon dark v-else
                                                                :size="$vuetify.breakpoint.smAndDown ? 30 : 30">mdi-account</v-icon>
                                                            <v-img :src="item.alumno.imagen"
                                                                v-if="item.alumno.imagen"></v-img>
                                                            <v-icon dark v-else
                                                                :size="$vuetify.breakpoint.smAndDown ? 30 : 30">mdi-account</v-icon>
                                                        </v-avatar>
                                                    </v-col>
                                                    <v-col xs="10" sm="10" md="10">
                                                        <h3 class="text-h6 text-sm-h5 responsive-font">{{ item.title }}
                                                            <v-chip v-if="item.type == 'private'" color="primary" small>
                                                                <v-icon>mdi-lock</v-icon> Privado
                                                            </v-chip>
                                                        </h3>
                                                        <h4 class="text-body-1 text-sm-body-2 responsive-font">{{
                                                            item.alumno.Nombres }} {{ item.alumno.Apellidos }}</h4>
                                                        <small class="text-caption text-sm-overline responsive-font-2">
                                                            {{ relativeDate(item.created_at) }}
                                                        </small>
                                                        <h5 :style="{ 'color': item.category.color }"
                                                            class="text-subtitle-2 text-sm-caption responsive-font">
                                                            {{ item.category.name }}
                                                        </h5>
                                                    </v-col>
                                                </v-row>
                                            </td>
                                            <!-- Combinar columnas de Respuestas y Likes en móviles -->
                                            <td class="responsive-padding" v-if="$vuetify.breakpoint.smAndDown">
                                                <div
                                                    style="display: flex; flex-direction: column; align-items: flex-start; gap: 4px;">
                                                    <div style="display: flex; align-items: center;">
                                                        <v-icon style="margin-right: 5px;">mdi-thumb-up</v-icon> {{
                                                        item.likes }}
                                                    </div>
                                                    <div style="display: flex; align-items: center;">
                                                        <v-icon style="margin-right: 5px;">mdi-comment</v-icon> {{
                                                        item.comments.length }}
                                                    </div>
                                                </div>
                                            </td>
                                            <!-- En pantallas grandes: Likes y Respuestas separados -->
                                            <td class="responsive-font" v-if="$vuetify.breakpoint.mdAndUp">
                                                <v-icon>mdi-comment</v-icon> {{ item.comments.length }}
                                            </td>
                                            <td class="responsive-font" v-if="$vuetify.breakpoint.mdAndUp">
                                                <v-icon>mdi-thumb-up</v-icon> {{ item.likes }}
                                            </td>
                                            <!-- Ocultar columna de Últimos en móviles -->
                                            <td v-if="$vuetify.breakpoint.mdAndUp">
                                                <v-avatar size="30"
                                                    v-for="(participant, i) in item.participants.filter(d => { return (d.status == 1) }).slice(0, 5)"
                                                    :key="i" class="responsive-avatar" style="cursor: pointer;">
                                                    <v-tooltip bottom>
                                                        <template v-slot:activator="{ on, attrs }"
                                                            v-if="participant.alumno != null">
                                                            <v-img v-if="participant.alumno.imagen" v-bind="attrs"
                                                                v-on="on" :src="participant.alumno.imagen"></v-img>
                                                            <v-avatar size="30" :color="getColor()" v-bind="attrs"
                                                                v-on="on" v-else>
                                                                <v-icon dark>mdi-account</v-icon>
                                                            </v-avatar>
                                                        </template>
                                                        <template v-slot:activator="{ on, attrs }" v-else>
                                                            <v-img v-if="participant.profesor.empleado.imagen"
                                                                v-bind="attrs" v-on="on"
                                                                :src="participant.profesor.empleado.imagen"></v-img>
                                                            <v-avatar size="30" :color="getColor()" v-bind="attrs"
                                                                v-on="on" v-else>
                                                                <v-icon dark>mdi-account</v-icon>
                                                            </v-avatar>
                                                        </template>
                                                        <span v-if="participant.alumno != null">{{
                                                            participant.alumno.Nombres }}</span>
                                                        <span v-else-if="participant.profesor != null">{{
                                                            participant.profesor.empleado.nombres }}</span>
                                                    </v-tooltip>
                                                </v-avatar>
                                            </td>
                                        </tr>
                                    </tbody>
                                </template>
                            </v-simple-table>


                        </div>

                        <!-- <v-col cols="12" xs="12" sm="12" md="12" xl="12" lg="12" v-else>
              <v-alert prominent type="info">
                No se ha publicado aún ningún tema {{ category ? 'en la categoría ' + category.name : '' }}
              </v-alert>
            </v-col> -->
                    </v-col>
                </v-row>
            </v-col>

            <template>
                <v-dialog v-model="showForm" max-width="800px" scrollable>
                    <v-card>
                        <v-card-title>
                            Agregar nuevo tema
                        </v-card-title>
                        <v-card-text>
                            <v-container>
                                <v-row>
                                    <v-col cols="12">
                                        <v-text-field v-model="title" label="Título del tema" required
                                            outlined></v-text-field>
                                    </v-col>
                                    <v-col cols="12">
                                        <v-textarea v-model.trim="content" label="Contenido del tema" type="text"
                                            no-details hide-details name="input-7-4" rows="5" outlined>
                                            <template slot="append">
                                                <v-icon color="green" @click="uploadFilesEvent()"
                                                    title="Adjuntar imágenes">mdi-file-image
                                                </v-icon>
                                                <v-icon color="orange" @click="uploadVideoEvent()"
                                                    title="Adjuntar video">mdi-file-video
                                                </v-icon>
                                            </template>
                                        </v-textarea>
                                    </v-col>
                                </v-row>
                                <v-row>
                                    <v-chip class="ma-2" close color="#f2f2f2" close-icon="mdi-delete" text-color="blue"
                                        v-for="(file, index) in files" :key="index"
                                        @click:close="file.id ? deleteFileThumnail(index, file.id) : deleteFileThumnail(index, null)">
                                        <v-sheet color="white" elevation="1" height="100" width="100"
                                            class="m-10 p-5 preview">
                                            <img :src="file.image" v-if="file.id" />
                                            <img :src="file.url" v-else />
                                        </v-sheet>
                                    </v-chip>
                                    <v-chip class="ma-2" close color="#f2f2f2" close-icon="mdi-delete" text-color="blue"
                                        @click:close="video = null" v-if="video">
                                        <v-sheet color="white" elevation="1" height="100" width="100"
                                            class="m-10 p-5 preview d-flex align-center justify-center pa-4 mx-auto">
                                            <v-icon x-large color="#095da1" class="mx-auto">mdi-filmstrip</v-icon>

                                        </v-sheet>
                                    </v-chip>
                                </v-row>
                                <v-row>
                                    <v-col cols="6">
                                        <v-select v-model="formCategory" :items="categories" item-text="name"
                                            item-value="id" label="Sección" persistent-hint return-object
                                            single-line></v-select>
                                    </v-col>
                                    <v-col cols="6">
                                        <v-select v-model="formType" :items="types" item-text="name" item-value="id"
                                            label="Visibilidad" persistent-hint return-object single-line></v-select>
                                    </v-col>
                                    <!-- <v-col cols="6">
                                    <v-select
                                      v-model="curso"
                                      :items="cursos"
                                      item-text="nombre"
                                      item-value="cod"
                                      label="cursos"
                                      persistent-hint
                                      return-object
                                      single-line
                                    ></v-select>
                                </v-col> -->
                                </v-row>
                                <input id="file-upload" type="file" @change="onFileChange" ref="fileInput"
                                    style="visibility: hidden;" multiple="" />
                                <input id="file-upload" type="file" @change="onVideoChange" ref="fileInputVideo"
                                    style="visibility: hidden;" />
                            </v-container>
                        </v-card-text>
                        <v-card-actions class="justify-space-around">
                            <v-btn color="success darken-1" text @click="addForum">
                                Guardar
                            </v-btn>
                            <v-btn color="blue darken-1" text @click="showForm = false">
                                Cerrar
                            </v-btn>
                        </v-card-actions>
                    </v-card>
                </v-dialog>
            </template>

            <template>
                <v-dialog v-model="showParticipants" max-width="600px" scrollable v-if="foro">
                    <v-card>
                        <v-card-title>
                            Participantes del foro
                        </v-card-title>
                        <v-divider></v-divider>
                        <v-card-text style="height: 300px;">
                            <v-list>
                                <!-- <div v-for="participants in parts" :key="participants.id"> -->
                                <div v-for="(participant, $index) in list" :key="$index">
                                    <v-list-item
                                        v-if="participant.status == 1 || (foro.alumno_id == user.IDStB && participant.status > 0)"
                                        :class="participant.status == 2 ? 'pending' : ''">

                                        <v-list-item-avatar>
                                            <v-list-item-avatar color="#a7ba38" title="Ver perfil"
                                                @click="openProfile(participant.alumno.IDStB)">
                                                <v-img :src="participant.alumno.imagen"
                                                    v-if="participant.alumno.imagen"></v-img>
                                                <v-icon dark v-else>mdi-account</v-icon>
                                            </v-list-item-avatar>
                                        </v-list-item-avatar>
                                        <v-list-item-content>
                                            <v-list-item-title>{{ participant.alumno.Nombres + ' ' +
                                                participant.alumno.Apellidos }}
                                                <v-chip class="ma-2" x-small color="success" outlined
                                                    v-if="participant.administrator">
                                                    Adminstrador
                                                </v-chip>
                                            </v-list-item-title>
                                        </v-list-item-content>
                                        <v-list-item-action
                                            v-if="isAdministrator() && user.IDStB !== participant.alumno_id">
                                            <v-btn @click="deleteParticipant(participant)" icon>
                                                <v-icon color="red lighten-1">mdi-delete-outline</v-icon>
                                            </v-btn>
                                        </v-list-item-action>
                                        <v-list-item-action v-if="isAdministrator() && participant.status == 2">
                                            <v-btn @click="accept(participant)" title="Aceptar solicitud" icon>
                                                <v-icon color="success lighten-1">mdi-check-circle-outline</v-icon>
                                            </v-btn>
                                        </v-list-item-action>
                                        <v-list-item-action v-if="isAdministrator() && participant.status == 2">
                                            <v-btn @click="rejectParticipant(participant)" title="Rechazar solicitud"
                                                icon>
                                                <v-icon color="warning lighten-1">mdi-close-circle-outline</v-icon>
                                            </v-btn>
                                        </v-list-item-action>
                                    </v-list-item>
                                </div>
                                <infinite-loading @infinite="infiniteHandler" ref="InfiniteLoading"></infinite-loading>
                                <!-- </div> -->
                            </v-list>
                        </v-card-text>
                        <v-divider></v-divider>
                        <v-card-actions class="justify-space-around">
                            <v-btn color="red darken-1" text @click="leaveForum()" small
                                v-if="foro.alumno_id !== user.IDStB && isParticipant()">
                                <v-icon>mdi-exit-to-app</v-icon> Salir del foro
                            </v-btn>
                            <v-btn color="blue darken-1" text @click="closeParticipants();
                            " small>
                                Cerrar
                            </v-btn>
                        </v-card-actions>
                    </v-card>
                </v-dialog>
            </template>
        </CardIeaAppMain>
    </div>
</template>

<script>
// import CardIeaApp from "../../components/CardIeaApp";
import CardIeaAppMain from "../../components/CardIeaAppMain";
import moment from "moment";
import InfiniteLoading from 'vue-infinite-loading';
moment.locale('es')

export default {
    name: "Foro",
    components: {
        // CardIeaApp,
        CardIeaAppMain,
        InfiniteLoading,
    },

    data: () => ({
        categories: [],
        selectedCategory: 0,
        items: [],
        category: null,
        showForm: false,
        formCategory: null,
        formType: null,
        cursos: [],
        curso: '',
        formCourse: null,
        title: '',
        content: '',
        types: [
            { id: 'public', name: 'Público' },
            { id: 'private', name: 'Privado' },
        ],
        video: null,
        selecteds: [],
        files: [],
        limit: 10,
        foro: null,
        comment: '',
        liked: false,
        disliked: false,
        showParticipants: false,
        parts: [],
        participants: [],
        idForo: '',

        idParticipants: null,
        page: 1,
        list: [],
        par: [],
        idForoData: null,
        selctForo: null,
        show: false,

    }),

    mounted() {
        if (this.$store.getters.user.borrado == 1 || this.$store.getters.user.alumno_mora == true) {
            this.$router.push({
                name: "Home"
            });
        }
        this.getCategories();
        this.getForums();
        this.getMateria();
    },

    computed: {
        user() {
            return this.$store.getters.user;
        },
    },

    methods: {

        relativeDate(date) {
            const now = new Date();
            const givenDate = new Date(date);

            // Calcular la diferencia en milisegundos
            const diffTime = now - givenDate;

            // Convertir la diferencia a días
            const diffDays = Math.floor(diffTime / (1000 * 60 * 60 * 24));

            // Calcular meses y años
            const diffMonths =
                now.getFullYear() * 12 +
                now.getMonth() -
                (givenDate.getFullYear() * 12 + givenDate.getMonth());
            const diffYears = now.getFullYear() - givenDate.getFullYear();

            if (diffDays === 0) {
                // Comparar horas para hoy
                const diffHours = Math.floor(diffTime / (1000 * 60 * 60));
                const diffMinutes = Math.floor(diffTime / (1000 * 60));
                if (diffHours === 0) {
                    if (diffMinutes === 0) {
                        return "Hace unos segundos";
                    } else if (diffMinutes === 1) {
                        return "Hace un minuto";
                    } else {
                        return `Hace ${diffMinutes} minutos`;
                    }
                } else if (diffHours === 1) {
                    return "Hace una hora";
                } else {
                    return `Hace ${diffHours} horas`;
                }
            } else if (diffDays === 1) {
                return "Ayer";
            } else if (diffDays < 30) {
                return `Hace ${diffDays} días`;
            } else if (diffMonths < 12) {
                return diffMonths === 1 ? "Hace un mes" : `Hace ${diffMonths} meses`;
            } else {
                return diffYears === 1 ? "Hace un año" : `Hace ${diffYears} años`;
            }
        },
        closeParticipants() {
            this.showParticipants = false
            this.$refs.InfiniteLoading.stateChanger.reset();
        },

        infiniteHandler($state) {
            this.$API
                .get({
                    url: "participants-forum/" + this.idParticipants + "?page=" + this.page,
                }).then(({ data }) => {
                    if (data.length) {
                        this.page += 1;
                        this.list.push(...data)
                        $state.loaded();
                    } else {
                        $state.complete();
                    }
                });
            console.log(this.list, 'soy list')
        },

        async getParts() {
            await this.$API
                .get({
                    url: "participants-forum/" + this.idParticipants + "?page=1",
                    data: {}
                })
                .then((res) => {
                    let dato = res;
                    this.parts = dato.data;
                    console.log(this.parts)
                });
        },
        async getMateria() {
            await this.$API
                .get({
                    url: "materia-codigo",
                    data: {}
                })
                .then(res => {

                    let dato = res.data;
                    this.cursos = dato;
                    console.log(this.types, this.cursos)
                });
        },
        create() {
            this.showForm = true
            this.foro = null
        },
        gettime(date_publish) {
            let current_date = moment();
            let published_date = moment(date_publish);
            return (moment.duration(current_date - published_date).humanize())
        },
        deleteFileThumnail(index, id) {
            this.files.splice(index, 1);
            if (id) {
                this.images_deleted.push(id)
                console.log(this.images_deleted)
            }
        },
        async uploadFilesEvent() {
            this.$refs.fileInput.click()
        },
        onFileChange(e) {
            let all = e.target.files;
            let r = this.files;
            [all].forEach((val) => {
                if (r.length < this.limit) {
                    for (const item of val) {
                        if (item.type.match('image.*')) {
                            item.url = URL.createObjectURL(item);
                            r.push(item);
                        }
                    }
                }
            });
            this.files = Array.from(r);
            if (this.limit < this.files.length) {
                alert('El número máximo de imágenes por publicación es ' + this.limit);
                this.files.splice(this.limit, (this.files.length - this.limit))
            }
        },
        onVideoChange(e) {
            let v = e.target.files[0];
            if (v.type.match('video.*')) {
                this.video = v;
            } else {
                alert('Agrega un formato válido de video')
            }
        },
        async getCategories() {
            let categoria_id = this.$route.params.categoria_id

            await this.$API
                .get({
                    url: "forum-categories?plat=bea",
                    data: {}
                })
                .then(e => {
                    e.forEach(element => {
                        this.categories.push(element)
                        if (element.id == categoria_id) {
                            this.category = element
                        }
                    });
                    console.log(this.categories)
                });
        },

        async getForums(category = null) {
            let categoria_id = this.$route.params.categoria_id

            let url = 'forums-by-category/' + categoria_id;
            if (category) {
                this.$router.push({
                    name: "ForoCategoria",
                    params: { categoria_id: category.id }
                });
            }
            await this.$API
                .get({
                    url: url,
                    data: {}
                })
                .then(res => {
                    this.items = res.data;
                    this.show = true;
                    console.log(this.items)
                });
        },

        async getForumsAll() {
            let url = 'forums?plat=bea';
            await this.$API
                .get({
                    url: url,
                    data: {}
                })
                .then(res => {
                    this.items = res.data;
                    this.show = true;
                    console.log(this.items)
                });
        },

        async selectCategory(cat = null) {
            if (cat !== null) {
                this.category = cat;
                this.getForums(cat)
                this.foro = null;
            } else {
                this.category = null;
                this.getForumsAll();
                this.foro = null;
            }
        },
        async openForo(id, selctForo) {
            this.list.length = 0
            this.page = 1
            this.comment = '';
            this.idParticipants = id;
            // this.idForoData = id;
            this.selctForo = selctForo;
            this.par = selctForo.participants;
            this.idForo = id;
            console.log(selctForo)
            let canView = true;
            if (selctForo.type == 'private') {
                let e = selctForo.participants.findIndex(d => { return (d.alumno_id == this.user.IDStB && d.status == 1) });
                if (e == -1) {
                    canView = false;
                    if (confirm('¿Este es un foro privado, te gustaría ser solicitar acceso?')) {
                        this.requestAcess(id);
                    }
                }
            }

            if (canView) {
                this.foro = selctForo
                /*this.$router.push({
                  name: "ForoDetalle",
                  params: {
                    id: id,
                    foro:foro
                  }
                });
                */
            }
        },
        editForum(id) {
            this.parts = [];
            this.getParts(id)
            this.showForm = true;
            this.title = this.foro.title
            this.formCategory = this.foro.category
            this.formType = this.foro.type
            this.content = this.foro.content
            this.files = this.foro.images;
            this.video = this.foro.video;
        },
        getColor() {
            let colors = ['#a7ba38', '#095da1', '#e79029', '#dd404a', '#8fc6dc'];
            let min = 0;
            var max = colors.length;
            var random = Math.floor(Math.random() * (max - min)) + min;
            return colors[random];
        },
        async addForum() {
            if (this.content && this.title && this.formCategory && this.formType) {
                var formData = new FormData();
                formData.append('title', this.title);
                formData.append('forum_category_id', this.formCategory.id);
                formData.append('type', this.formType.id);
                formData.append('content', this.content);

                if (this.files.length > 0) {
                    formData.append('cantidadImagen', this.files.length);
                    let i = 0;
                    for (let file of this.files) {
                        formData.append(`imagen_${i}`, file, file.name);
                        i++;

                    }
                }

                if (this.files.length > 0) {
                    formData.append('cantidadImagen', this.files.length);
                    let i = 0;
                    for (let file of this.files) {
                        formData.append(`imagen_${i}`, file, file.name);
                        i++;

                    }
                }

                if (this.video) {
                    formData.append('video', this.video);
                }

                if (this.selecteds.length > 0) {
                    let taggeds = new Array();
                    this.selecteds.forEach((val) => {
                        if (this.content.includes(val.value)) {
                            taggeds.push(val.id);
                        }
                    });
                    formData.append('tagged', taggeds.join(','));
                }

                formData.append('cod', this.curso.cod);
                console.log(formData);
                let url = this.foro ? 'forums/' + this.foro.id : 'forums'
                await this.$API
                    .post({
                        url: url,
                        data: formData
                    }).then(res => {
                        console.log(res)
                        this.foro = res;
                        this.items.unshift(res);
                        this.title = '';
                        this.content = '';
                        this.files = [];
                        this.video = null;
                        this.showForm = false;
                        this.par = res.participants
                    });
            } else {
                alert('Completa todos los campos')
            }
        },
        async addComment() {
            if (this.comment) {
                var formData = new FormData();
                formData.append('comment', this.comment);
                formData.append('taged', '');
                await this.$API
                    .post({
                        url: "forums-comment/" + this.foro.id,
                        data: formData
                    }).then(res => {
                        console.log(res)
                        res.likes = 0;
                        this.foro.comments.unshift(res);
                        this.comment = '';
                    });
            } else {
                alert('Escribe primero tu comentario')
            }
        },
        async like() {
            await this.$API
                .post({
                    url: "forums-like/" + this.foro.id,
                    data: {}
                }).then(res => {
                    if (res) {
                        this.foro.likes++;
                        this.liked = true;
                    }
                });
        },
        async likeComment(comment) {
            await this.$API
                .post({
                    url: "forums-comment-like/" + comment.id,
                    data: {}
                }).then(res => {
                    if (res) {
                        comment.likes++;
                    }
                });
        },
        async dislike() {
            await this.$API
                .delete({
                    url: "forums-like/" + this.foro.id,
                    data: {}
                }).then(res => {
                    if (res) {
                        this.foro.likes--;
                        this.disliked = true;
                    }
                });
        },
        async uploadVideoEvent() {
            this.$refs.fileInputVideo.click()
        },
        async deleteComment(comment, j) {
            if (confirm('¿Estas seguro de querer eliminar este comentario?')) {
                await this.$API
                    .delete({
                        url: "forums-comment/" + comment.id,
                        data: {}
                    }).then(res => {
                        if (res) {
                            this.foro.comments.splice(j, 1)
                        }
                    });
            }
        },
        async deleteForum() {
            if (confirm('¿Estas seguro de querer eliminar este tema?')) {
                await this.$API
                    .delete({
                        url: "forums/" + this.foro.id,
                        data: {}
                    }).then(res => {
                        if (res) {
                            this.foro = null
                            this.getForums(this.category);
                        }
                    });
            }
        },
        openParticipants() {
            this.showParticipants = true;
        },
        isAdministrator() {
            return (this.par.filter(d => { return (d.alumno_id == this.user.IDStB && d.administrator == 1) }).length > 0) ? true : false
        },
        isParticipant() {
            return (this.par.filter(d => { return (d.alumno_id == this.user.IDStB && d.status == 1) }).length > 0) ? true : false
        },
        async leaveForum() {
            if (confirm('¿Estas seguro de querer salirte de este foro?')) {
                await this.$API
                    .post({
                        url: "forums/leave/" + this.foro.id,
                    }).then(res => {
                        if (res == true) {
                            this.foro = null;
                            this.getForums(this.category);
                        }
                    });
            }
        },
        async requestAcess(id = null) {
            let foroId = id ? id : this.foro.id;
            await this.$API
                .post({
                    url: "forums/access/" + foroId,
                }).then(res => {
                    if (res == true) {
                        alert('Tu solicitud ha sido enviada')
                    }
                });
        },
        async accept(participant) {
            await this.$API
                .post({
                    url: "forums/accept/" + participant.id,
                }).then(res => {
                    if (res == true) {
                        alert('Integrante aceptado')
                        participant.status = 1;
                    }
                });
        },
        async deleteParticipant(participant) {
            await this.$API
                .delete({
                    url: "forum-participant/" + participant.id,
                }).then(res => {
                    if (res == true) {
                        alert('Integrante eliminado')
                        participant.status = 0;
                    }
                });
        },
        async rejectParticipant(participant) {
            await this.$API
                .post({
                    url: "forums/reject/" + participant.id,
                }).then(res => {
                    if (res == true) {
                        alert('Integrante rechazado')
                        participant.status = 0;
                    }
                });
        }
    }
}
</script>


<style scoped>
@media (max-width: 600px) {


    /* Se oculta la columna del avatar en pantallas pequeñas */
    .responsive-comment-row .avatar-column {
        display: none !important;
    }

    .custom-textarea {
        margin-top: -35px !important;
        margin-left: -8px !important;
    }

    /* Ajuste de la columna de texto para que ocupe todo el espacio disponible */
    .responsive-comment-row .text-column {
        width: 100% !important;
        padding-left: 5px;
        padding-right: 11px;
    }

    ::v-deep .v-application .primary--text {
        color: white !important;
        caret-color: #125ea5 !important;
        font-size: 1.2rem;
    }

    .v-application .primary--text-edit {
        color: gray !important;
        caret-color: #125ea5 !important;
        font-size: 1rem;
        padding-top: 10px;
        padding-bottom: 10px;
        font-weight: bold;
    }

    /* Responsividad para márgenes */
    .responsive-padding {
        padding-left: 8px !important;
    }

    .responsive-font {
        font-size: 0.9rem !important;
    }

    .responsive-font-2 {
        font-size: 0.9rem !important;
        padding-top: 10px;
        padding-bottom: 10px;
    }

    .responsive-avatar {
        margin-left: -20px !important;
    }

    .responsive-title {
        font-size: 1.1rem !important;
    }

    .v-toolbar__title {
        font-size: 1.1rem !important;
    }

    .centered-avatar {
        justify-content: center;
        display: flex;
        margin-top: 20px;
        margin-bottom: 20px;
    }

    .panel1 h4 {
        font-size: 1rem !important;
    }

    .panel1 .v-list-item__title {
        font-size: 0.8rem !important;
    }

    /* Flexbox para la fila que contiene el avatar y el texto */
    .responsive-comment-row {
        display: flex;
        flex-wrap: wrap;
        align-items: center;
    }

    .avatar-column {
        flex: 0 0 20%;
        /* Avatar ocupa el 20% */
        margin-right: 20px;
        /* Separación entre avatar y texto */
    }

    .text-column {
        flex: 1;
        /* El texto ocupa el resto del espacio */
        margin-right: 20px;
        /* Separación entre texto y siguientes elementos */
    }

    /* Ajustes para alinear avatar */
    .avatar-wrapper {
        display: flex;
        justify-content: center;
        align-items: center;
        margin-top: 30px;
    }
}

@media (min-width: 601px) {
    /* Ajustes para pantallas grandes */

    .responsive-comment-row {
        display: flex;
        align-items: center;
    }

    .centered-avatar {
        justify-content: center;
        display: flex;
        margin-top: 20px;
        margin-bottom: 20px;
    }

    .avatar-column {
        flex: 0 0 10%;
        margin-right: 20px;
    }

    .text-column {
        flex: 1;
        margin-right: 20px;
    }

    .custom-textarea {
        margin-top: -35px !important;
        width: 66%;
    }

    .avatar-wrapper {
        display: flex;
        justify-content: center;
        align-items: center;
        margin-top: 20px
    }


}

.theme--light.v-timeline::before {
    background: white;
}

.content-forum {
    word-wrap: break-word;
    overflow-wrap: break-word;
    max-width: 100%;
    white-space: normal;
    box-sizing: border-box;
}

.text-column {
    max-width: 100%;
    padding: 10px;
    box-sizing: border-box;
}

/* Estilo para mover la etiqueta 'Escribe tu comentario' hacia arriba */
::v-deep .custom-textarea .v-label {
    transform: translateY(-10px) !important;
    /* Mueve la etiqueta hacia arriba */
    color: #333 !important;
    /* Ajusta el color de la fuente si es necesario */
}
</style>
